import { render } from "./AppDynamicChangeHeader.vue?vue&type=template&id=4077d32e&scoped=true&ts=true"
import script from "./AppDynamicChangeHeader.vue?vue&type=script&lang=ts"
export * from "./AppDynamicChangeHeader.vue?vue&type=script&lang=ts"

import "./AppDynamicChangeHeader.vue?vue&type=style&index=0&id=4077d32e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4077d32e"]])

export default __exports__